<template>
  <div class="quote__part">
    <div class="row">
      <h3>
        {{ title }} <span class="quote__caption">({{ $t("registration.quote.initial_cost") }})</span>
      </h3>
      <RegistrationCompensationTableComponent
        v-if="data.columns && data.data && !data.hasError"
        :data="data"
        :isEditable="isEditable"
        @editCost="editCost"
      />
      <div v-else class="col-12 col-md3">
        <AlertBlock
          :text="data && data.hasError ? data.hasError : $t('global.empty.no_data_available')"
          type="primary"
        />
      </div>
    </div>
    <BlockLoader :loading="loading" />
  </div>
</template>

<script>
import RegistrationCompensationTableComponent from "@/components/registration/quote/table/RegistrationCompensationTableComponent.vue";
import AlertBlock from "@/components/blocks/AlertBlock.vue";
import BlockLoader from "@/components/blocks/BlockLoader.vue";

export default {
  name: "RegistrationQuoteAmountBlockComponent",
  components: { BlockLoader, AlertBlock, RegistrationCompensationTableComponent },
  props: {
    data: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    isEditable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  emits: ["editCost"],
  data() {
    return {};
  },
  methods: {
    editCost(cell) {
      this.$emit("editCost", cell);
    },
  },
};
</script>

<style lang="scss" scoped>
.quote {
  h3 {
    color: var(--primary-color);
    margin: 15px 0;

    @include dark-theme {
      color: $white;
    }
  }

  &__part {
    position: relative;
  }

  &__caption {
    color: $m-color_7;
    font-size: 12px;

    @include dark-theme {
      color: $white;
    }
  }
}
</style>
